import { Card, CardContent, CardHeader, Menu, MenuItem } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import SearchIcon from "@material-ui/icons/Search";
import FormDropdown from "components/FormFields/FormDropdown";
import { useDataset } from "hooks/useDataset";
import { Controller, useFormContext } from "react-hook-form";

import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import GenericButton from "components/Buttons/GenericButton";
import FormDatePickerV2 from "components/FormFields/FormDatePickerV2";
import { useState } from "react";
import { DATASET, REPORT_FILE_NAME } from "utils/const";

const useStylesGeneric = makeStyles(componentStylesGeneric);

const FilterSection = ({ onSubmit: onSubmitFilters, onReset: onResetFilters, onExport, exportDisabled }) => {
  const classes = useStylesGeneric();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));

  const {
    handleSubmit,
    getValues,
    control,
    formState: { errors },
    trigger,
  } = useFormContext();

  const { data: contractApprovalStatus } = useDataset({ name: DATASET.CONTRACT_APPROVAL_STATUS });
  const { data: contractType } = useDataset({ name: DATASET.CONTRACT_TYPE });

  const [exportMenuAnchorEl, setExportMenuAnchorEl] = useState(null);
  const exportMenuOpen = Boolean(exportMenuAnchorEl);

  const handleOpenExportMenu = (event) => {
    setExportMenuAnchorEl(event.currentTarget);
  };

  const handleCloseExportMenu = () => {
    setExportMenuAnchorEl(null);
  };

  const onSubmit = async () => {
    if (onSubmitFilters) {
      await onSubmitFilters();
    }
  };

  const handleClearFilters = async () => {
    if (onResetFilters) {
      await onResetFilters();
    }
  };

  return (
    <Card classes={{ root: classes.cardRoot }}>
      <CardHeader
        classes={{
          action: classes.cardHeaderAction,
          title: classes.cardHeader,
        }}
        title={
          <Grid container>
            <Box>Pesquisa de Pedidos de Homologação de contratos</Box>
          </Grid>
        }
      ></CardHeader>
      <CardContent>
        <Box>
          <form id="filter-contractApprovals" onSubmit={handleSubmit(onSubmit)}>
            <Grid container classes={{ root: classes.containerPadding }}>
              <Grid item xs={12} sm={6} md={4}>
                <FormGroup>
                  <FormLabel classes={{ root: classes.filterLabel }}>Nº. do Pedido</FormLabel>
                  <Controller
                    name="requestNumber"
                    control={control}
                    defaultValue=""
                    component={Box}
                    render={({ field: { onChange, name, value } }) => (
                      <OutlinedInput
                        name={name}
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                        }}
                        fullWidth
                        autoComplete="off"
                        type="text"
                        placeholder="Insira o nº. do pedido"
                        endAdornment={
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        }
                      />
                    )}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormDatePickerV2
                  name="startDate"
                  label="Data de Submissão (Desde)"
                  control={control}
                  maxDateToday={true}
                  minDateToday={false}
                  endDateFieldName="endDate"
                  errors={errors}
                  classes={classes}
                  trigger={trigger}
                  getValues={getValues}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormDatePickerV2
                  name="endDate"
                  label="Data de Submissão (Até)"
                  control={control}
                  maxDateToday={true}
                  minDateToday={false}
                  startDateFieldName="startDate"
                  errors={errors}
                  classes={classes}
                  trigger={trigger}
                  getValues={getValues}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormGroup>
                  <FormLabel classes={{ root: classes.filterLabel }}>Nome do Trabalhador</FormLabel>
                  <Controller
                    name="workerName"
                    control={control}
                    defaultValue=""
                    component={Box}
                    render={({ field: { onChange, name, value } }) => (
                      <OutlinedInput
                        name={name}
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                        }}
                        fullWidth
                        autoComplete="off"
                        type="text"
                        placeholder="Insira o nome do trabalhador"
                        endAdornment={
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        }
                      />
                    )}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormGroup>
                  <FormLabel classes={{ root: classes.filterLabel }}>NISS</FormLabel>
                  <Controller
                    name="ssn"
                    control={control}
                    defaultValue=""
                    component={Box}
                    render={({ field: { onChange, name, value } }) => (
                      <OutlinedInput
                        name={name}
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                        }}
                        fullWidth
                        autoComplete="off"
                        type="text"
                        placeholder="Insira o NISS do trabalhador"
                        endAdornment={
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        }
                      />
                    )}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormGroup>
                  <FormLabel classes={{ root: classes.filterLabel }}>NIF</FormLabel>
                  <Controller
                    name="nif"
                    control={control}
                    defaultValue=""
                    component={Box}
                    render={({ field: { onChange, name, value } }) => (
                      <OutlinedInput
                        name={name}
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                        }}
                        fullWidth
                        autoComplete="off"
                        type="text"
                        placeholder="Insira o NIF do trabalhador"
                        endAdornment={
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        }
                      />
                    )}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormDropdown
                  name="contractTypeId"
                  label="Tipo de Contrato"
                  mappingTo="code"
                  control={control}
                  options={contractType}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormDropdown
                  name="contractApprovalStatusId"
                  label="Estado"
                  mappingTo="code"
                  control={control}
                  options={contractApprovalStatus}
                />
              </Grid>

              <Grid item xs={12} md={12} classes={{ root: classes.textAlignRight }}>
                <Box
                  style={{
                    display: "flex",
                    justifyContent: isXs ? "stretch" : "flex-end",
                    flexDirection: isXs ? "column" : "row",
                    columnGap: 12,
                    rowGap: 12,
                    flexWrap: "wrap",
                  }}
                >
                  <GenericButton onClick={handleClearFilters} color="ghost" fullWidth={isXs}>
                    Limpar Filtros
                  </GenericButton>
                  <span
                    style={
                      isXs
                        ? {
                            width: "100%",
                            display: "block",
                          }
                        : undefined
                    }
                  >
                    <GenericButton
                      typeSubmit={false}
                      color="primary"
                      onClick={handleOpenExportMenu}
                      disabled={!!exportDisabled}
                      fullWidth={isXs}
                    >
                      Exportar <KeyboardArrowDownIcon />
                    </GenericButton>
                    <Menu
                      anchorEl={exportMenuAnchorEl}
                      open={exportMenuOpen}
                      onClose={handleCloseExportMenu}
                      keepMounted
                    >
                      <MenuItem
                        onClick={() => {
                          handleCloseExportMenu();
                          onExport?.(REPORT_FILE_NAME.PDF_EXTENSION);
                        }}
                      >
                        PDF
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleCloseExportMenu();
                          onExport?.(REPORT_FILE_NAME.EXCEL_EXTENSION);
                        }}
                      >
                        Excel
                      </MenuItem>
                    </Menu>
                  </span>
                  <GenericButton type="submit" form="filter-contractApprovals" color="primary" fullWidth={isXs}>
                    Pesquisar
                  </GenericButton>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </CardContent>
    </Card>
  );
};

export default FilterSection;
